import { get, sortBy, isEmpty } from 'lodash';
import { composeReducers } from 'common/util/composeReducers';

import {
    API_INTEGRATIONS_START_LOADING,
    API_INTEGRATIONS_END_LOADING,
    API_INTEGRATIONS_LOAD_SUCCESS,
    API_INTEGRATIONS_CLEAN,
    API_INTEGRATION_TOGGLE_SUCCESS,
    SET_SELECTED_INTEGRATION_MAPPING_ID,
    LOAD_INTEGRATION_DETAIL_SUCCESS,
    SAVE_INTEGRATION_API_CONFIG_SUCCESS,
    SAVE_INTEGRATION_COMPLION_AUTH_CLIENT_ID_SUCCESS,
    CLEAN_SELECTED_INTEGRATION_MAPPING_ID
} from 'common/actions/apiConfiguration';

export const startApiIntegrationsLoadingReducer = (state, action) => {
    if (action.type === API_INTEGRATIONS_START_LOADING) {
        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                isLoading: true
            }
        };
    }

    return state;
};

export const endApiIntegrationsLoadingReducer = (state, action) => {
    if (action.type === API_INTEGRATIONS_END_LOADING) {
        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                isLoading: false
            }
        };
    }

    return state;
};

export const loadApiIntegrationsSuccessReducer = (state, action) => {
    if (action.type === API_INTEGRATIONS_LOAD_SUCCESS) {
        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                apiIntegrations: sortBy(action.payload, ['name'])
            }
        };
    }

    return state;
};

export const cleanApiIntegrationsReducer = (state, action) => {
    if (action.type === API_INTEGRATIONS_CLEAN) {
        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                apiIntegrations: []
            }
        };
    }

    return state;
};

export const toggleApiIntegrationSuccessReducer = (state, action) => {
    if (action.type === API_INTEGRATION_TOGGLE_SUCCESS) {
        const updatedIntegration = action.payload;
        const apiIntegrations = get(state, 'apiConfiguration.apiIntegrations', []);
        const newApiIntegrations = apiIntegrations.map(integration => {
            if (integration.id === updatedIntegration.id) {
                return {
                    ...integration,
                    enabled: updatedIntegration.enabled
                };
            }

            return integration;
        });

        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                apiIntegrations: newApiIntegrations
            }
        };
    }

    return state;
};

export const setSelectedIntegrationMappingIdReducer = (state, action) => {
    if (action.type === SET_SELECTED_INTEGRATION_MAPPING_ID) {
        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                selectedIntegrationMappingId: action.payload
            }
        };
    }

    return state;
};

export const loadIntegrationDetailSuccessReducer = (state, action) => {
    if (action.type === LOAD_INTEGRATION_DETAIL_SUCCESS) {
        const updatedIntegration = action.payload;
        const apiIntegrations = get(state, 'apiConfiguration.apiIntegrations', []);
        let updatedApiIntegrations = null;
        if (isEmpty(apiIntegrations)) {
            updatedApiIntegrations = [updatedIntegration];
        } else {
            updatedApiIntegrations = apiIntegrations.map(integration => {
                if (integration.mappingId === updatedIntegration.mappingId) {
                    return {
                        ...integration,
                        ...updatedIntegration
                    };
                }
    
                return integration;
            });
        }

        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                apiIntegrations: updatedApiIntegrations
            }
        };
    }

    return state;
};

export const saveIntegrationApiConfigSuccessReducer = (state, action) => {
    if (action.type === SAVE_INTEGRATION_API_CONFIG_SUCCESS) {
        const updatedIntegration = action.payload;
        const apiIntegrations = get(state, 'apiConfiguration.apiIntegrations');
        const updatedApiIntegrations = apiIntegrations.map(integration => {
            if (integration.mappingId === updatedIntegration.mappingId) {
                return {
                    ...integration,
                    ...updatedIntegration
                };
            }

            return integration;
        });

        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                apiIntegrations: updatedApiIntegrations
            }
        };
    }

    return state;
};

export const saveIntegrationComplionAuthClientIdSuccessReducer = (state, action) => {
    if (action.type === SAVE_INTEGRATION_COMPLION_AUTH_CLIENT_ID_SUCCESS) {
        const updatedIntegration = action.payload;
        const apiIntegrations = get(state, 'apiConfiguration.apiIntegrations');
        const updatedApiIntegrations = apiIntegrations.map(integration => {
            if (integration.mappingId === updatedIntegration.mappingId) {
                return {
                    ...integration,
                    complionAuth0ClientId: updatedIntegration.complionAuth0ClientId
                };
            }

            return integration;
        });

        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                apiIntegrations: updatedApiIntegrations
            }
        };
    }

    return state;
};

export const cleanSelectedIntegrationMappingIdReducer = (state, action) => {
    if (action.type === CLEAN_SELECTED_INTEGRATION_MAPPING_ID) {
        return {
            ...state,
            apiConfiguration: {
                ...state.apiConfiguration,
                selectedIntegrationMappingId: ''
            }
        };
    }

    return state;
};

export default composeReducers(
    startApiIntegrationsLoadingReducer,
    endApiIntegrationsLoadingReducer,
    loadApiIntegrationsSuccessReducer,
    cleanApiIntegrationsReducer,
    toggleApiIntegrationSuccessReducer,
    setSelectedIntegrationMappingIdReducer,
    loadIntegrationDetailSuccessReducer,
    saveIntegrationApiConfigSuccessReducer,
    saveIntegrationComplionAuthClientIdSuccessReducer,
    cleanSelectedIntegrationMappingIdReducer
);
